import { Navigate } from 'react-router-dom'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

// Stub: real settings routes are added in the main ticketing PR (#94078).
// Redirect all /settings/ticketing/* traffic to settings root so users with
// the feature flag enabled don't hit a blank/404 route.
const ticketingSettingsRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.settings.ticketing.path,
    element: <Navigate replace to={navigation.settings.fullPath()} />,
    children: [
      {
        path: '*',
        element: <Navigate replace to={navigation.settings.fullPath()} />,
      },
    ],
  },
]

export default ticketingSettingsRoutes
